<template>
  <div class="app-container relative m-auto min-h-full bg-[#efeeee]">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <keep-alive :include="keepAliveList">
          <component :is="Component" />
        </keep-alive>
      </transition>
    </router-view>
    <ArrowPopup></ArrowPopup>
    <QRCodePopup></QRCodePopup>
    <QAPopup></QAPopup>
    <ConsultationPopup></ConsultationPopup>
    <AdPopup></AdPopup>
    <SvgIcon v-if="isTest" name="testtag" class="absolute top-0 left-0 z-99 h-16 w-16"></SvgIcon>
    <van-config-provider
      :theme-vars="{
        floatingBubbleSize: '36px',
        floatingBubbleIconSize: '20px',
      }"
      theme-vars-scope="global"
    >
      <van-floating-bubble
        v-if="backType === 'home'"
        :gap="16"
        icon="wap-home-o"
        @click="router.replace({ name: 'HomePage' })"
        class="bg-[#75c5f099]! hover:bg-[#75c5f0dd]! active:bg-[#75c5f0dd]!"
      />
      <van-floating-bubble
        :gap="16"
        v-else-if="backType === 'back'"
        icon="arrow-left"
        @click="router.back()"
        class="bg-[#75c5f099]! hover:bg-[#75c5f0dd]! active:bg-[#75c5f0dd]!"
      />
    </van-config-provider>
  </div>
</template>

<script setup lang="ts">
import { browerVersion, getBrowerAppId } from './utils'

const isTest = import.meta.env.MODE === 'staging'
const { width: windowWidth, height: windowHeight } = useWindowSize()
const containerWidth = computed(() => {
  const version = browerVersion()
  if (version.mobile) {
    return `${windowWidth.value}px`
  } else {
    return `${Math.floor(windowHeight.value * 0.625)}px`
  }
})

provide('containerWidth', containerWidth)
const route = useRoute()
const keepAliveList = ref<string[]>([])

watch(
  () => route,
  () => {
    if (route.name && route.meta.keepAlive && !keepAliveList.value.includes(route.name as string)) {
      keepAliveList.value.push(route.name as string)
    }
  },
  { deep: true },
)

const router = useRouter()
const backType = computed<'home' | 'back' | ''>(() => {
  if (route.name === 'HomePage') {
    return ''
  }
  if (!router.options.history.state.back) {
    return 'home'
  }
  if (router.options.history.state.back) {
    return 'back'
  }
  return ''
})

onMounted(() => {
  getBrowerAppId()
})
</script>

<style lang="scss" scoped>
.app-container {
  width: v-bind(containerWidth);
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.25s ease-out;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
